import React from 'react';
import { TOAST } from 'constants/common';

const ToastContent = ({ title, text, content, type = TOAST.TYPE.INFO, onClick }) => {
    const isError = type === TOAST.TYPE.ERROR || type === 'err';
    const color = isError ? '#AD0025' : '#005F0F';
    const bodyText = text || content;

    return (
        <div onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
            <span style={{ color: color, fontSize: 16, fontWeight: 600 }}>{title}</span>
            <br />
            <span style={{ color: color, fontSize: 14 }}>{bodyText}</span>
        </div>
    );
};

export default ToastContent;
